import React, { useEffect } from 'react';
import AttendanceRecordReportDataTable from './AttendanceRecordReportDataTable';

const AttendanceRecordReportIndex = ({ rrhh }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <AttendanceRecordReportDataTable rrhh={rrhh} />;
};

export default AttendanceRecordReportIndex;
